var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopmentEnvironment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#2c76d3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88 0C4.43 0 0 4.43 0 9.88C0 15.33 4.43 19.75 9.88 19.75C15.33 19.75 19.75 15.32 19.75 9.88C19.75 4.44 15.32 0 9.88 0ZM9.88 19C4.85 19 0.75 14.91 0.75 9.88C0.75 4.85 4.85 0.75 9.88 0.75C14.91 0.75 19 4.85 19 9.88C19 14.91 14.91 19 9.88 19Z",
    fill: "#2c76d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5493 9.55L13.4793 6.48L12.7793 7.18999L15.4893 9.9L12.7793 12.62L13.4793 13.33L16.5493 10.26C16.7493 10.06 16.7493 9.75 16.5493 9.55Z",
    fill: "#2c76d3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27914 6.48L3.19914 9.55C3.00914 9.75 3.00914 10.06 3.19914 10.26L6.27914 13.33L6.97914 12.62L4.25914 9.9L6.97914 7.18999L6.27914 6.48Z",
    fill: "#2c76d3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 14.88H8.70063L12.0306 4.88H10.9706L7.64062 14.88Z",
    fill: "#2c76d3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentEnvironment);
export default __webpack_public_path__ + "static/media/development-environment.9bed11fde652afecf68d01ba1e097cd4.svg";
export { ForwardRef as ReactComponent };